import gql from 'graphql-tag';
import { mutation } from 'services/graphql';

export const unLockSurfaceNodeFromUpdateMutation = gql`
  mutation unLockSurfaceNodeFromUpdate($id: ID!) {
    unLockSurfaceNodeFromUpdate(id: $id) {
      error
      success
    }
  }
`;

export default mutation(unLockSurfaceNodeFromUpdateMutation);
